<template>
    <Popup
        :showHeader="false"
        :showPopup="visible"
        @hidePopup="close"
    >
        <div class="payment-popup">
            <CloseIcon v-active-touch class="close-icon interactive-icon" @click.native="close" />
            <span class="payment-popup-title">{{ title }}</span>
            <div ref="iframeContainer"></div>
        </div>
    </Popup>
</template>

<script>
import Popup from "@/components/popups/Popup.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";

export default {
    name: "PaymentIframePopup",
    components: {
        Popup,
        CloseIcon,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Payment",
        },
        htmlContent: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            iframeElement: null,
        };
    },
    watch: {
        visible(val) {
            if (val && this.htmlContent) {
                this.$nextTick(() => {
                    this.renderIframe();
                });
            } else {
                this.clearIframe();
            }
        },
        htmlContent(val) {
            if (this.visible && val) {
                this.$nextTick(() => {
                    this.renderIframe();
                });
            }
        }
    },
    methods: {
        close() {
            this.$emit("update:visible", false);
            this.$emit("close");
        },
        renderIframe() {
            const container = this.$refs.iframeContainer;
            if (!container) return;
            
            this.clearIframe();

            const iframe = document.createElement("iframe");
            iframe.className = "powertranz-form"; // Keep the class for styling
            iframe.style.width = "100%";
            iframe.style.border = "none";
            iframe.style.height = "700px";
            iframe.style.marginTop = "32px";
            
            container.appendChild(iframe);
            this.iframeElement = iframe;

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(this.htmlContent);
            iframeDoc.close();
        },
        clearIframe() {
            const container = this.$refs.iframeContainer;
            if (container && this.iframeElement) {
                try {
                    container.removeChild(this.iframeElement);
                } catch (e) {
                    // Ignore if already removed
                }
                this.iframeElement = null;
            }
        },
    },
    beforeDestroy() {
        this.clearIframe();
    },
};
</script>

<style lang="scss" scoped>
.payment-popup {
    padding: 32px 16px 0;
    text-align: center;
    position: relative;

    .close-icon {
        position: absolute;
        top: 13px;
        right: 12px;
        width: 34px;
        height: 34px;
        padding: 5px;
        cursor: pointer;
    }
    .payment-popup-title {
        font-size: 20px;
        font-weight: 590;
        line-height: 23.87px;
    }
}
</style>
